// eslint-disable-next-line max-classes-per-file
import { TaggableNamed } from '../base/taggable-named';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';

export type NodeSize = 'None' | 'Small' | 'Medium' | 'Large' | 'XLarge' | 'XXLarge' | 'XXXLarge';
export type NodeSizeFamily = 'None' | 'MemoryOptimized';

@Metamodel.model({
    name: 'SparkAutoPause'
})
export class SparkAutoPause {
    @Metamodel.attribute({
    })
    public delayInMinutes?: number;

    @Metamodel.attribute({
    })
    public enabled?: boolean;
}

@Metamodel.model({
    name: 'SparkAutoScale'
})
export class SparkAutoScale {
    @Metamodel.attribute({
    })
    public maxNodeCount?: number;

    @Metamodel.attribute({
    })
    public minNodeCount?: number;

    @Metamodel.attribute({
    })
    public enabled?: boolean;
}

@Metamodel.model({
    name: 'SparkLibraryRequirements'
})
export class SparkLibraryRequirements {
    @Metamodel.attribute({
    })
    public readonly time?: string;

    @Metamodel.attribute({
    })
    public content?: string;

    @Metamodel.attribute({
    })
    public filename?: string;
}

@Metamodel.model({
    name: 'SparkLibraryInfo'
})
export class SparkLibraryInfo {
    @Metamodel.attribute({
    })
    public name?: string;

    @Metamodel.attribute({
    })
    public path?: string;

    @Metamodel.attribute({
    })
    public containerName?: string;

    @Metamodel.attribute({
    })
    public uploadedTimestamp?: string;

    @Metamodel.attribute({
    })
    public fileType?: string;
}

@Metamodel.model({
    name: ModelConstants.bigDataPool,
    display: [shellStringResources.SynapseSparkPools],
    reusable: true,
    referable: true,
    transient: true // Make it transient as we don't need it persist via Shell for now
})
export class BigDataPool extends TaggableNamed {
    @Metamodel.attribute({
    })
    public rawTags: {[key: string]: string};

    @Metamodel.attribute({
    })
    public location: string;

    @Metamodel.attribute({
    })
    public autoPause?: SparkAutoPause;

    @Metamodel.attribute({
    })
    public autoScale?: SparkAutoScale;

    @Metamodel.attribute({
    })
    public creationDate?: string;

    @Metamodel.attribute({
    })
    public nodeCount?: number;

    @Metamodel.attribute({
    })
    public nodeSize?: NodeSize;

    @Metamodel.attribute({
    })
    public nodeSizeFamily?: NodeSizeFamily;

    @Metamodel.attribute({
    })
    public provisioningState?: string;

    @Metamodel.attribute({
    })
    public sparkVersion?: string;

    @Metamodel.attribute({
    })
    public sparkEventsFolder?: string;

    @Metamodel.attribute({
    })
    public libraryRequirements?: SparkLibraryRequirements;

    @Metamodel.attribute({
    })
    public defaultSparkLogFolder?: string;

    @Metamodel.attribute({
    })
    public isComputeIsolationEnabled?: boolean;

    @Metamodel.attribute({
    })
    public sparkConfigProperties?: SparkLibraryRequirements;

    @Metamodel.attribute({
    })
    public sessionLevelPackagesEnabled?: boolean;

    @Metamodel.attribute({
    })
    public customLibraries?: SparkLibraryInfo[];
}
